import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SMSSend = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.16725 17.925L5.8125 20.4375V17.0625H4.6875C4.38913 17.0625 4.10298 16.944 3.892 16.733C3.68103 16.522 3.5625 16.2359 3.5625 15.9375V4.6875C3.5625 4.38913 3.68103 4.10298 3.892 3.892C4.10298 3.68103 4.38913 3.5625 4.6875 3.5625H19.3125C19.6109 3.5625 19.897 3.68103 20.108 3.892C20.319 4.10298 20.4375 4.38913 20.4375 4.6875V12.5625"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.524 13.7465L11.6389 16.269C11.5411 16.3106 11.4573 16.3792 11.3973 16.4669C11.3373 16.5546 11.3036 16.6576 11.3003 16.7638C11.297 16.87 11.3242 16.975 11.3786 17.0662C11.433 17.1575 11.5124 17.2312 11.6074 17.2788L13.683 18.3166L14.7208 20.3929C14.7684 20.4877 14.8421 20.567 14.9333 20.6214C15.0244 20.6758 15.1292 20.7031 15.2352 20.7C15.3413 20.6968 15.4443 20.6635 15.5321 20.6038C15.6199 20.5441 15.6887 20.4606 15.7307 20.3631L18.2578 14.478C18.3021 14.3755 18.3145 14.2619 18.2934 14.1522C18.2723 14.0425 18.2187 13.9416 18.1396 13.8627C18.0605 13.7839 17.9595 13.7306 17.8497 13.7099C17.7399 13.6891 17.6264 13.7019 17.524 13.7465V13.7465Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
